export default __webpack_public_path__ + "static/media/give_me_bread_icon.d7732dfc.png";